<template>
  <div class="left_block my-courses">
    <p class="header">Мои курсы</p>

    <CoursesFilter @submit="loadData" :search="search" :categories-list="categoriesList" />

    <CoursesTable
      :is-loading="isLoading"
      :courses-list="coursesList"
      @click="openCourseInfo"
      :categories-list="categoriesList"
      @init-sort="initSort"
    />
  </div>
</template>

<script>
import CoursesFilter from '@/components/user/my-courses/CoursesFilter'
import CoursesTable from '@/components/user/my-courses/CoursesTable'

export default {
  components: {
    CoursesFilter,
    CoursesTable
  },
  data() {
    return {
      search: {
        name: '',
        category: 0,
        sort: 'surname',
        sort_type: 'desc'
      },
      isLoading: false
    }
  },
  computed: {
    coursesList() {
      return this.$store.state.courses.userCoursesList.courses.filter((el) => el.status === 1)
    },
    categoriesList() {
      return this.$store.state.categories.categoriesList
    }
  },
  methods: {
    initSort(fieldName, sortType) {
      this.search.sort_type = sortType
      this.search.sort = fieldName
      this.loadData()
    },
    loadData() {
      this.isLoading = true
      const qs = require('qs')
      const params = {}
      Object.keys(this.search).forEach((el) => {
        if (this.search[el] && this.search[el] !== 0) {
          params[el] = this.search[el]
        }
      })
      this.$axios2
        .get('courses?' + qs.stringify(params))
        .then((resp) => {
          this.isLoading = false
          this.$store.commit('setUserCoursesList', { list: resp.data })
        })
        .catch(this.$errorToast)
    },
    openCourseInfo(courseId) {
      this.$router.push('/course-info/' + courseId)
    }
  },
  mounted() {
    this.loadData()
  }
}
</script>
